var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_vm._v(_vm._s(_vm._f("translate")('Welcome')))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }